import { BaseApi } from '../../api/apiBase'
import { Sponsor } from '../types/sponsor'

class SponsorsApi extends BaseApi {
    async getSponsors(eventSlug: string): Promise<Sponsor[]> {
        // Use standard get() method - BaseApi will handle JSON:API deserialization
        return this.get<Sponsor[]>(`/events/${eventSlug}/sponsors`)
    }
}

export const sponsorsApi = new SponsorsApi()